import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-modal',
  templateUrl: './modal.component.html'
})
export class ModalComponent implements OnInit {
  @Output() cancelEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() okEvent: EventEmitter<boolean> = new EventEmitter();
  @Output() dismissEvent: EventEmitter<boolean> = new EventEmitter();
  @Input() modalTitle: String = 'Title not set';
  @Input() modalBody: String = 'Body not set';
  @Input() modalOkButtonText: String = 'Ok';
  @Input() modalCancelButtonText: String = 'Cancel';

  constructor(public modal: NgbActiveModal) {}

  ngOnInit() {}

  cancelClick(): void {
    this.modal.dismiss('Cancel click');
    this.cancelEvent.emit(true);
  }

  okClick(): void {
    this.modal.close('Ok click');
    this.okEvent.emit(true);
  }

  dismiss(): void {
    this.modal.dismiss('Dismiss click');
    this.dismissEvent.emit(true);
  }

  isRecarding() {
    return this.modalTitle === 'Confirm Replacement';
  }
}
